<template>
  <div class="signup-form-wrapper border">
    <h3>Sign Up</h3>
    <form class="signup-form">
      <div class="input-grp">
        <label class="block-label" for="email">Email</label>
        <input v-model="form.email" type="text" />
      </div>
      <div class="input-grp">
        <label class="block-label" for="password">Password</label>
        <input v-model="form.password" type="password" />
      </div>
      <div class="input-grp">
        <label class="block-label" for="password">Confirm Password</label>
        <input type="password" />
      </div>
      <div class="input-grp">
        <label for="terms">Terms &amp; Conditions</label>
        <input v-model="form.termsAndConditions" type="checkbox" />
      </div>
      <button @click.prevent="signup" type="submit">Submit</button>
    </form>
  </div>
</template>

<script>
import { defaultConfig } from '../utilities/Requester.js'

export default {
  name: 'Signup',
  props: {
    msg: String
  },
  data:function(){
    return {
      form:{
        email:"",
        password:"",
        termsAndConditions:false
      }
    } 
  },
  methods:{
    signup:function(){
      console.log(this.form);
      let signup = document.authRequest('/signup');
      let options = defaultConfig()
      options.method = "POST"
      options.headers['Content-Type'] = "application/json"
      options.body = JSON.stringify(this.form);

      let verifyResponse = response => {
        if(response.data.access_token){
          this.$emit('success', response.data)
        } else {
          this.$emit('error', response.data)
        }
      } 

      let handleError = error => {
        console.log(error);
        this.$emit('error', error)
      }

      signup(options)
        .then(verifyResponse)
        .catch(handleError);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.signup-form-wrapper {
  box-sizing:border-box;
  display: grid;
  min-height:100px;
  max-width:700px;
  grid-template-columns: 1fr;
  text-align:center;
  padding:1em;
}
.input-grp {
  text-align:left;
}
.block-label {
  display:block;
}
.border {
  border: 1px dashed navy;
}
</style>
